import { Component, HostBinding, Input, OnChanges } from '@angular/core';

/**
 * A client's order history (mockup customers/profile "Order History"): address search, then Date,
 * Inspection Address (opens the Overview), Role, Inspector, Total Charges. `jobs` are the
 * api/client/details `jobs`. Used on Client Details and inside each Agent Outreach task.
 */
@Component({
    selector: 'app-client-order-history',
    templateUrl: './client-order-history.component.html',
    styleUrls: ['../../../modules/client/components/client-details/client-details.component.scss']
})
export class ClientOrderHistoryComponent implements OnChanges {
    @Input() jobs: any[] = [];
    @Input() titleId = 'cdtHistoryTitle';
    // Fits a narrow card (the Agent Outreach widget) instead of scrolling sideways.
    @HostBinding('class.compact') @Input() compact = false;
    searchText = '';
    filtered: any[] = [];

    ngOnChanges() {
        this.filter();
    }

    filter() {
        const jobs = this.jobs || [];
        const search = this.searchText.trim().toLowerCase();
        this.filtered = !search ? jobs : jobs.filter(job => {
            if (!job.property) {
                return false;
            }
            const p = job.property;
            return `${p.property_address1 || ''} ${p.property_city || ''} ${p.property_state || ''} ${p.property_zip || ''}`.toLowerCase().indexOf(search) !== -1;
        });
    }

    hasDate(value): boolean {
        return !!value && String(value).indexOf('0000-00-00') !== 0;
    }

    address(job): string {
        const p = job.property || {};
        return [p.property_address1, p.property_city, p.property_state].map(s => (s || '').trim()).filter(Boolean).join(', ');
    }
}
